// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-1f9ed8ea]{height:32px}", "",{"version":3,"sources":["webpack://./resources/client/layouts/mobile/components/MobileLogoMenu.vue"],"names":[],"mappings":"AAGA,uBACE,WAFF","sourcesContent":["\n@import \"../../../styles/variables/variables\";\n\n.logo {\n  height: $headerHeight - 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
